import React, { useState, useEffect } from 'react';
import Column from '@amzn/meridian/column';
import Text from '@amzn/meridian/text';
import Box from '@amzn/meridian/box';
import LaborPlanGrid from './LaborPlanGrid';
import LaborSummary from './LaborSummary';
import AvailableLaborChart from './AvailableLaborChart';
import RequiredLaborChart from './RequiredLaborChart';
import VolumeChart from './VolumeChart';
import WIPChart from './WIPChart';
import LaborOpportunities from './LaborOpportunities';
import CycleHeader from './CycleHeader';
import { TEXTS } from '../../utils/constants';
import { getCycleDisplayName } from '../../utils/helpers';

const Section = ({ children }) => <div className="fp-results-section">{children}</div>;

const ResultsView = ({
  gridData,
  laborSummary,
  availableCycles,
  intervals,
  laborAvailabilityChart,
  requiredHCPerInterval,
  availableHCPerInterval,
  opportunityHCPerInterval,
  volumeWIPChart,
  laborOpportunities,
  planVersion
}) => {
  const sortedCycles = [...availableCycles].sort();
  const [selectedCycle, setSelectedCycle] = useState(sortedCycles[0] || 'CYCLE_1');
  useEffect(() => {
    setSelectedCycle((prev) => (sortedCycles.length > 0 && !sortedCycles.includes(prev) ? sortedCycles[0] : prev));
  }, [availableCycles]);
  const gridCycleData = gridData?.[selectedCycle] || null;
  const currentTPH = Math.round(gridCycleData?.tph || 0);
  const volumeWIPCycleData = volumeWIPChart?.[selectedCycle] || null;
  if (!gridData) {
    return (
      <Box type="fill" spacingInset="400" style={{ width: '100%' }}>
        <Column spacing="400" alignmentHorizontal="stretch" width="100%">
          <Box type="outline" spacingInset="400" style={{ backgroundColor: 'white', textAlign: 'center' }}>
            <Text type={TEXTS.T2} color="secondary">
              Run a plan to see results
            </Text>
          </Box>
        </Column>
      </Box>
    );
  }
  return (
    <Box type="fill" spacingInset="400" style={{ width: '100%' }}>
      <div className="fp-results-panel">
        <Section>
          <CycleHeader
            cycles={sortedCycles}
            selectedCycle={selectedCycle}
            onSelect={setSelectedCycle}
            displayName={getCycleDisplayName}
            tph={currentTPH}
          />
        </Section>
        <Section>
          <LaborPlanGrid gridCycleData={gridCycleData} intervals={intervals} />
        </Section>
        <Section>
          <LaborSummary laborSummary={laborSummary} intervals={intervals} />
        </Section>
        <Section>
          <AvailableLaborChart
            laborAvailabilityChart={laborAvailabilityChart}
            intervals={intervals}
            planVersion={planVersion}
          />
        </Section>
        <Section>
          <RequiredLaborChart intervals={intervals} gridCycleData={gridCycleData} />
        </Section>
        <Section>
          <VolumeChart volumeChartData={volumeWIPCycleData} intervals={intervals} />
        </Section>
        <Section>
          <WIPChart wipChartData={volumeWIPCycleData} intervals={intervals} />
        </Section>
        {Array.isArray(laborOpportunities) && laborOpportunities.length > 0 && (
          <Section>
            <LaborOpportunities
              requiredHCPerInterval={requiredHCPerInterval}
              availableHCPerInterval={availableHCPerInterval}
              opportunityHCPerInterval={opportunityHCPerInterval}
              requiredLaborHoursPerInterval={laborSummary?.grandTotals?.laborHours || []}
              laborOpportunities={laborOpportunities}
              intervals={intervals}
            />
          </Section>
        )}
      </div>
    </Box>
  );
};
export default ResultsView;
